import type { Nullable, PriceId, Weight } from '@iheartjane/types';
import { formatCurrency } from '@iheartjane/utils';

interface BuildPriceStringArgs {
  /** product.amount */
  amount?: Nullable<string>;
  availableWeights: Weight[];
  price?: number;
  priceId: PriceId;
  weightFilters?: string[];
}

export const buildPriceString = ({
  amount,
  availableWeights,
  price,
  priceId,
  weightFilters,
}: BuildPriceStringArgs) => {
  const label = availableWeights
    .filter(({ id }) => id === priceId)
    .map(({ label }) => label)[0];

  const filteredAvailableWeights =
    weightFilters &&
    availableWeights.filter(({ id }) =>
      weightFilters.includes(id.split('_').join(' '))
    );

  const isMultiWeightProduct = availableWeights.length >= 1 && !amount;
  const basePrice = formatCurrency(price);

  const hasMultiWeights = isMultiWeightProduct && availableWeights.length !== 1;
  const filteringBySingleWeight =
    filteredAvailableWeights && filteredAvailableWeights.length === 1;

  return `${
    hasMultiWeights && !filteringBySingleWeight ? 'Starting at' : ''
  } ${basePrice} ${isMultiWeightProduct ? `/ ${label}` : ''}`.trim();
};
